var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Colour",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85169 6.06549C6.83427 6.04812 6.82449 6.02454 6.82449 5.99994C6.82449 5.97534 6.83427 5.95176 6.85169 5.93439L10.8378 1.9486C11.0548 1.73138 11.0545 1.37944 10.8373 1.16252C10.6201 0.945609 10.2681 0.945857 10.0512 1.16308L6.06543 5.14739C6.04806 5.1648 6.02447 5.17459 5.99988 5.17459C5.97528 5.17459 5.95169 5.1648 5.93432 5.14739L1.94853 1.16308C1.73162 0.946062 1.37985 0.945979 1.16283 1.16289C0.945813 1.37981 0.94573 1.73158 1.16264 1.9486L5.14806 5.93439C5.16548 5.95176 5.17526 5.97534 5.17526 5.99994C5.17526 6.02454 5.16548 6.04812 5.14806 6.06549L1.16264 10.0517C1.02233 10.192 0.96756 10.3966 1.01898 10.5883C1.0704 10.78 1.22018 10.9298 1.41192 10.9811C1.60366 11.0324 1.80821 10.9776 1.94853 10.8372L5.93432 6.85101C5.95169 6.8336 5.97528 6.82381 5.99988 6.82381C6.02447 6.82381 6.04806 6.8336 6.06543 6.85101L10.0512 10.8372C10.2681 11.0542 10.6199 11.0543 10.8369 10.8374C11.0539 10.6204 11.054 10.2687 10.8371 10.0517L6.85169 6.06549Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconMobile);
export default __webpack_public_path__ + "static/media/closeIconMobile.f2dbe98b48a9817eac45a3cce9555f1d.svg";
export { ForwardRef as ReactComponent };